<a class="skip-link" href="#main-content">Skip to main content</a>
<ug-alert></ug-alert>
<main>
  @if (isSignedIn()) {
    <header class="container-application" [class]="navbarBgClass">
      <sqep-header
        [helpEntry]="helpEntry()"
        [navbarBgClass]="navbarBgClass"
        [clientLogoAsset]="clientLogoAsset"
        [sidenavOpen]="!collapsed()"
        (toggle)="collapsed.set(!collapsed()); storeMenuState(collapsed())"
      />
    </header>
    <div class="page-title" [class]="navbarBgClass">
      @if (router.url.split('?')[0] !== '/home') {
        <span
          [class.page-title-position]="collapsed()"
          [class.page-title-expanded]="!collapsed()"
        >
          <h1>{{ title() }}</h1>
        </span>
      } @else {
        <span
          [class.page-title-position]="collapsed()"
          [class.page-title-expanded]="!collapsed()"
        >
          <h1>Welcome back, {{ givenName() }}!</h1>
        </span>
      }
    </div>
    <mat-sidenav-container>
      <mat-sidenav
        id="sidebar-nav"
        [autoFocus]="'false'"
        appDrawerAutosizeHack
        opened
        mode="side"
        [fixedInViewport]="'fixed'"
        [style.width]="sidenavWidth()"
        [style.margin-top.px]="67"
      >
        <sqep-custom-sidenav
          [heading]="clientHeading"
          [subTitle]="clientSubTitle"
          [clientLogoAsset2]="clientLogoAsset2"
          [collapsed]="collapsed()"
          [applicationName]="applicationName()"
          (changeCollapsedState)="collapsed.set(true)"
        />
      </mat-sidenav>

      <mat-sidenav-content class="content" [style.margin-left]="sidenavWidth()">
        <div class="top-panel" [ngClass]="navbarBgClass"></div>
        <div
          id="main-content"
          tabindex="-1"
          style="padding: 0px 24px 24px 24px; outline: none"
        >
          <router-outlet
            (activate)="onRouterOutletActivate($event)"
          ></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  } @else {
    <router-outlet />
  }
</main>
@if (isSignedIn()) {
  <sqep-footer
    [isSignedIn]="isSignedIn()"
    [navbarBgClass]="navbarBgClass"
    [guiBuildVersion]="buildNumber()"
    [apiBuildVersion]="esqepBuildVersionNumber()"
    [csodApiBuildVersion]="csodEsqepBuildVersionNumber()"
  />
}
